<template>

  <div id="app">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>

      <v-card color="grey lighten-5" flat>

        <v-layout row wrap>

          <v-flex xs12 md12 sm12>

            <v-toolbar size="120px" dark color="info">

              <v-toolbar-title> {{$t('Return-Ticket-Invoice-Control')}} </v-toolbar-title>

              <v-spacer></v-spacer>

              <v-text-field

                flat=""

                solo-inverted=""

                hide-details

                v-model="searchsatilanbilet"

                :label="$t('Search')"

                append-icon="search"

              ></v-text-field>

              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> Mail Gönder

</v-btn>

              <v-menu bottom="" left>

                <v-btn slot="activator" dark icon>

                  <v-icon>more_vert</v-icon>

                </v-btn>

                <v-list>

                  <v-list-tile @click="getListHtml()">

                    <v-list-tile-title

                      >Html {{ $t("Download") }}</v-list-tile-title

                    >

                  </v-list-tile>

                  <v-list-tile @click="getListExcel()">

                    <v-list-tile-title

                      >Excel {{ $t("Download") }}</v-list-tile-title

                    >

                  </v-list-tile>

                </v-list>

              </v-menu>

            </v-toolbar>

          </v-flex>

<!-- MAIL GÖNDER DIALOG -->

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>Mail Gönder</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              label="Kime (e-posta)"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              label="Agency Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              label="Doc Type (sabit)"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              label="Agent Full Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              label="Mesaj"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>Gönder

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>

          <v-container fluid>

            <v-layout row wrap>

              <v-flex pb-3 xs12 sm12 md12>

                <v-card flat>

                  <v-form ref="formgunluksatis" v-model="valid" lazy-validation>

                    <v-layout row wrap>

                      <v-flex pb-3 xs12 sm12 md12>

                        <v-card flat>

                          <v-layout row wrap>

                            <v-flex xs12 sm6 pt-2 md2>

                              <tarihcomp

                                :etiket="$t('Date')"

                                :detaygizle="false"

                                :rules="[

                                  (v) => !!v || $t('Please-select-a-date'),

                                ]"

                                v-bind:defaultvalue="'ok'"

                                v-bind:value="Rapor.BaslangicTarih"

                                v-model="Rapor.BaslangicTarih"

                              ></tarihcomp>

                            </v-flex>

                            <v-flex xs12 sm6 pt-2 md2>

                              <tarihcomp

                                :etiket="$t('Date')"

                                :detaygizle="false"

                                :rules="[

                                  (v) => !!v || $t('Please-select-a-date'),

                                ]"

                                v-bind:defaultvalue="'ok'"

                                v-bind:value="Rapor.BitisTarih"

                                v-model="Rapor.BitisTarih"

                              ></tarihcomp>

                            </v-flex>

                            <v-flex pt-2>

                              <v-layout align-center="">

                                <div v-if="load1">

                                  <v-btn

                                    color="info"

                                    @click="getList()"

                                    fab

                                    small=""

                                    dark

                                  >

                                    <v-icon>search</v-icon>

                                  </v-btn>

                                </div>

                                <div v-if="progress">

                                  <v-layout align-center="">

                                    <v-progress-circular

                                      indeterminate

                                      :width="4"

                                      color="blue"

                                    ></v-progress-circular>

                                  </v-layout>

                                </div>

                                <v-badge color="white" :overlap="true">

                                  <template v-slot:badge>

                                    <v-icon

                                      v-if="filtrevarmi"

                                      large

                                      color="green"

                                    >

                                      check_circle_outline

                                    </v-icon>

                                  </template>

                                  <v-btn

                                    small=""

                                    @mouseenter="tooltip = true"

                                    @mouseleave="tooltip = false"

                                    ref="fab"

                                    @click="filtrele()"

                                    color="info"

                                    fab

                                    dark

                                  >

                                    <v-icon>filter_list</v-icon>

                                  </v-btn>

                                  <v-tooltip

                                    bottom=""

                                    :activator="el"

                                    v-model="tooltip"

                                  >

                                    <span>{{ $t("Add-Search-Filter") }}</span>

                                  </v-tooltip>

                                </v-badge>

                              </v-layout>

                            </v-flex>

                          </v-layout>

                        </v-card>

                      </v-flex>

                    </v-layout>

                  </v-form>

                </v-card>

              </v-flex>

              <v-flex xs12 v-if="kayitvarmi" sm12 md12 pb-3>

                <v-card flat class="white--text">

                  <v-card flat="">

                    <v-card-actions>

                      <v-layout row wrap>

                        <v-flex xs12 sm12>

                          <v-card flat>

                            <ReportTable
                              :headers="refundInvoiceHeaders"
                              :items="refundInvoiceItems"
                              storage-key="iadebiletfatura_columns"
                              :loading="progress"
                              :has-searched="reportHasSearched"
                              :show-search="true"
                              :search-label="$t('Search')"
                              :show-frontend-export="true"
                              :export-title="$t('Return-Ticket-Invoice-Control')"
                              :export-meta-items="refundInvoiceExportMetaItems"
                              :export-summary-cards="refundInvoiceSummaryCards"
                              :rows-per-page-items="[20, 50, 100, 200, 500, 1000]"
                            ></ReportTable>

                          </v-card>

                        </v-flex>

                      </v-layout>

                    </v-card-actions>

                  </v-card>

                </v-card>

              </v-flex>

            </v-layout>

          </v-container>

          <v-snackbar

            :timeout="timeout"

            :top="y === 'top'"

            :bottom="y === 'bottom'"

            :right="x === 'right'"

            :left="x === 'left'"

            :multi-line="mode === 'multi-line'"

            :vertical="mode === 'vertical'"

            v-model="snackbar"

          >

            {{ text1 }}

            <v-btn flat color="pink" @click.native="snackbar = false">{{

              $t("Close")

            }}</v-btn>

          </v-snackbar>

          <v-dialog

            v-model="dialogfiltre"

            scrollable=""

            persistent=""

            max-width="350px"

          >

            <v-card color="grey lighten-5">

              <v-card-title>{{ $t("Filter-selection") }}</v-card-title>

              <v-divider></v-divider>

              <v-card-text>

                <v-layout row="" wrap="">

                  <v-flex xs12 sm12 md12 pa-1>

                    <v-card class="white--text">

                      <v-card color="grey lighten-5" flat="">

                        <v-card-actions>

                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>

                              <v-radio-group

                                v-model="Rapor.UcusTipi"

                                :label="$t('Ticket-Type')"

                                column

                              >

                                <v-radio

                                  :label="$t('All')"

                                  :value="0"

                                ></v-radio>

                                <v-radio

                                  :label="$t('Domestic-Line')"

                                  :value="1"

                                ></v-radio>

                                <v-radio

                                  :label="$t('International-Line')"

                                  :value="2"

                                ></v-radio>

                              </v-radio-group>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-radio-group

                                v-model="Rapor.RaporTip"

                                label="Rapor Tip"

                                column

                              >

                                <v-radio

                                  label="Iade Tarihine Göre"

                                  value="0"

                                ></v-radio>

                                <v-radio

                                  label="Iade Fatura Tarihine Göre"

                                  value="1"

                                ></v-radio>

                                <v-radio

                                  label="İşlem Tarihine Göre"

                                  value="2"

                                ></v-radio>

                              </v-radio-group>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <cariaracomp

                                v-bind:etiket="'Cari Kod'"

                                :rules="true"

                                v-bind:value="Rapor.CariKod"

                                v-model="Rapor.CariKod"

                              ></cariaracomp>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox

                                v-model="Rapor.KdvAyir"

                                label="KDV Ayır"

                                hide-details=""

                              ></v-checkbox>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox

                                v-model="tumsirketler"

                                :label="$t('All-Companies')"

                                hide-details=""

                              ></v-checkbox>

                            </v-flex>

                          </v-layout>

                        </v-card-actions>

                      </v-card>

                    </v-card>

                  </v-flex>

                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn

                  color="blue darken-1"

                  flat

                  @click.native="filtreiptal()"

                  >{{ $t("cancel_button") }}</v-btn

                >

                <v-btn

                  color="blue darken-1"

                  flat

                  @click.native="filtrekayit()"

                  >{{ $t("Apply-Filters") }}</v-btn

                >

              </v-card-actions>

            </v-card>

          </v-dialog>

        </v-layout>

      </v-card>

    </v-app>

  </div>

</template>



<script>

import auth from "../../../../api/auth";

import tarihcomp from "../../customcomp/tarihim";

import helpers from "@/components/app/customcomp/helpers.js";

import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";

import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue";

import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

import cariaracomp from "@/components/app/customcomp/cariaracomp";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";

export default {

  data() {

    return {

      mailDialog: false,

        mailValid: false,

        mailLoading: false,

        mailPayload: {

          To: "",

          AgencyName: "",

          DocType: "Kesen Kişi Performans Raporu - Performance Analysis of Ticket Agent", 

          AgentFullName: "",

          CustomBody: ""

        },

        rules: {

          required: v => !!v || 'Zorunlu alan',

          email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'

        },

      sayfayetki: {

        Screen: false,

        Update: false,

        Save: false,

        Delete: false,

        Status: false,

        Message: null,

        islem: 0,

      },

      headerRefund: [

        {

          text: "Tarih",

        },

        {

          text: "Fatura No",

        },

        {

          text: "Cari Kodu",

        },

        {

          text: "Havayolu Kodu",

        },

        {

          text: "Bilet No",

        },

        {

          text: "Dekont No",

        },

        {

          text: "Acente Kodu",

        },

        {

          text: "Iade Alan Kişi",

        },

        {

          text: "Yolcu Adı",

        },

        {

          text: "Iade Fatura Tarihi",

        },

        {

          text: "Iade Belge No",

        },

        {

          text: "Tip",

        },

        {

          text: "Tutar",

        },

        {

          text: "Ceza",

        },

        {

          text: "Iskonto",

        },

        {

          text: "Kdv",

        },

        {

          text: "Yff",

        },

        {

          text: "Ka",

        },

        {

          text: "Alan Tax",

        },

        {

          text: "Net Tutar",

        },

        {

          text: "Gelen Iade Fat. Tutar",

        },

        {

          text: "Iade Servis",

        },

      ],

      itemRefundSum: {},

      itemRefund: [],

      filtrevarmi: false,
        reportHasSearched: false,

      kayitvarmi: false,

      search: "",

      searchsatilanbilet: null,

      Rapor: {

        BaslangicTarih: null,

        BitisTarih: null,

        UcusTipi: 0, //0 tumu  1 : İç Hat, 2 : Dış Hat

        CariKod: null,

        SirketKodu: null,

        KdvAyir: false,

        RaporTip: "0", // 0 : Iade Tarih , 1 : Iade Fatura Tarih , 2 : islem tarih

      },

      valid: true,

      tumsirketler: "",

      items: [],

      load: false,

      load1: true,

      dialogfiltre: false,

      progress: false,

      tooltip: false,

      el: null,

      yok: false,

      butondurum: true,

      snackbar: false,

      y: "top",

      x: "right",

      mode: "",

      timeout: 6000,

      text1: "",

      dictionary: {

        custom: {

          tarihsec: {

            required: () => this.$t("Please-select-a-date"),

          },

          tarihsec1: {

            required: () => this.$t("Please-select-a-date"),

          },

        },

      },

    };

  },

  beforeRouteEnter(to, from, next) {

    next((vm) => {

      vm.prevRoute = from.path;

    });

  },

  beforeMount: beforeMount,

  mounted() {

    this.$validator.localize("en", this.dictionary);

    this.el = this.$refs.fab.$el;

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {

    } else {

      this.$refs.yetkidialog

        .open(this.sayfayetki.Message, this.sayfayetki.islem)

        .then((sonuc) => {

          if (sonuc == true) {

            if (this.prevRoute != null) {

              let url = "#" + this.prevRoute;

              window.open(url, "_self");

            } else {

              let url = "#/";

              window.open(url, "_self");

            }

          }

        });

    }

  },

  filters: {

    dateformat: function (t) {

      return helpers.dateformat(t);

    },

    moneyformat: function (m) {

      return helpers.moneyformat(m);

    },

    bakiyekontrol: function (m) {

      return helpers.bakiyekontrol(m);

    },

  },

  components: {

    tarihcomp: tarihcomp,

    referansmerkezicomp,

    yuzdeinput,

    yetkidialog,

    cariaracomp,
      ReportTable

  },

  watch: {},

  computed: {
    refundInvoiceHeaders() {
      return [
        { text:this.$t('Date'), value:'Tarih', type:'date', align:'left', visible:true, sortable:true },
        { text:this.$t('Invoice-No'), value:'FaturaNo', type:'text', align:'left', visible:true, sortable:true },
        { text:this.$t('Customer-Code'), value:'CariKodu', type:'text', align:'left', visible:true, sortable:true },
        { text:this.$t('Airline-Code'), value:'HavayoluKodu', type:'text', align:'left', visible:true, sortable:true },
        { text:this.$t('Ticket-No'), value:'BiletNo', type:'text', align:'left', visible:true, sortable:true },
        { text:'Dekont No', value:'DekontNo', type:'text', align:'left', visible:true, sortable:true },
        { text:this.$t('Agency-Code'), value:'AcenteKodu', type:'text', align:'left', visible:true, sortable:true },
        { text:'İade Alan Kişi', value:'IadeAlanKisi', type:'text', align:'left', visible:true, sortable:true },
        { text:this.$t('Name-of-Passenger'), value:'YolcuAdi', type:'text', align:'left', visible:true, sortable:true },
        { text:'İade Fatura Tarihi', value:'IadeFaturaTarihi', type:'date', align:'left', visible:true, sortable:true },
        { text:'İade Belge No', value:'IadeBelgeNo', type:'text', align:'left', visible:true, sortable:true },
        { text:this.$t('Type'), value:'Tip', type:'text', align:'left', visible:true, sortable:true },
        { text:this.$t('Amount'), value:'_Tutar', type:'money', align:'right', visible:true, sortable:true },
        { text:this.$t('Penalty'), value:'_Ceza', type:'money', align:'right', visible:true, sortable:true },
        { text:this.$t('Discount'), value:'_Iskonto', type:'money', align:'right', visible:true, sortable:true },
        { text:this.$t('Tax-v2'), value:'_Kdv', type:'money', align:'right', visible:true, sortable:true },
        { text:'YFF', value:'_Yff', type:'money', align:'right', visible:true, sortable:true },
        { text:'KA', value:'_Ka', type:'money', align:'right', visible:true, sortable:true },
        { text:'Alan Tax', value:'_AlanTax', type:'money', align:'right', visible:true, sortable:true },
        { text:this.$t('Net'), value:'_NetTutar', type:'money', align:'right', visible:true, sortable:true },
        { text:'Gelen İade Fatura Tutarı', value:'_GelenIadeFaturaTutar', type:'money', align:'right', visible:true, sortable:true },
        { text:'İade Servis', value:'_IadeServis', type:'money', align:'right', visible:true, sortable:true }
      ];
    },
    refundInvoiceItems() {
      return (this.itemRefund || []).map(function(item) {
        var row=Object.assign({},item), t=item && item.Tutarlar ? item.Tutarlar : {};
        Object.keys(t).forEach(function(key){ row['_'+key]=t[key]; });
        return row;
      });
    },
    refundInvoiceExportMetaItems() {
      var flightMap={'0':this.$t('All'),'1':this.$t('Domestic-Line'),'2':this.$t('International-Line')};
      var reportMap={'0':'İade Tarihine Göre','1':'İade Fatura Tarihine Göre','2':'İşlem Tarihine Göre'};
      return [
        { label:this.$t('Starting-Date'), value:this.Rapor.BaslangicTarih, type:'date' },
        { label:this.$t('Finishing-Date'), value:this.Rapor.BitisTarih, type:'date' },
        { label:this.$t('Ticket-Type'), value:flightMap[String(this.Rapor.UcusTipi)] || '' },
        { label:this.$t('Report-Type'), value:reportMap[String(this.Rapor.RaporTip)] || '' },
        { label:this.$t('Currentcode_label'), value:this.Rapor.CariKod || '' },
        { label:'KDV Ayır', value:this.Rapor.KdvAyir ? 'Evet' : 'Hayır' },
        { label:this.$t('All-Companies'), value:this.tumsirketler === true ? 'Evet' : 'Hayır' }
      ];
    },
    refundInvoiceSummaryCards() {
      var t=this.itemRefundSum || {};
      return [{ title:this.$t('Grand-Total'), items:[
        {label:this.$t('Amount'),value:t.Tutar||0,type:'money'},
        {label:this.$t('Penalty'),value:t.Ceza||0,type:'money'},
        {label:this.$t('Discount'),value:t.Iskonto||0,type:'money'},
        {label:this.$t('Tax-v2'),value:t.Kdv||0,type:'money'},
        {label:'YFF',value:t.Yff||0,type:'money'},
        {label:'KA',value:t.Ka||0,type:'money'},
        {label:'Alan Tax',value:t.AlanTax||0,type:'money'},
        {label:this.$t('Net'),value:t.NetTutar||0,type:'money'},
        {label:'Gelen İade Fatura Tutarı',value:t.GelenIadeFaturaTutar||0,type:'money'},
        {label:'İade Servis',value:t.IadeServis||0,type:'money'}
      ] }];
    }
  },

  methods: {

  openMailDialog() {

    if (this.$refs.mailForm && this.$refs.mailForm.resetValidation) {

      this.$refs.mailForm.resetValidation();

    }

    const pageDocType = "İade Bilet Fatura Kontrol Raporu - Return Ticket Invoice Check";

    if (!this.mailPayload.DocType || this.mailPayload.DocType === "Kesen Kişi Performans Raporu - Performance Analysis of Ticket Agent") {

      this.mailPayload.DocType = pageDocType;

    }

    this.mailDialog = true;

  },

  closeMailDialog() {

    this.mailDialog = false;

  },

  sendMail() {

    const _this = this;

    if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {

      return;

    }

    const bas = (_this.Rapor && _this.Rapor.BaslangicTarih) ? new Date(_this.Rapor.BaslangicTarih) : null;

    const bit = (_this.Rapor && _this.Rapor.BitisTarih) ? new Date(_this.Rapor.BitisTarih) : null;

    if (!(bas && bit) || bas > bit) {

      _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');

      _this.snackbar = true;

      return;

    }

    const credentialsRaw = window.localStorage.getItem('credentials');

    const credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};

    const companyCode = _this.tumsirketler === true

      ? '0'

      : (credentials && credentials.SirketKodu) ? credentials.SirketKodu : null;

    const inputObj = {

      SirketKodu: companyCode,

      BaslangicTarih: _this.Rapor.BaslangicTarih,

      BitisTarih: _this.Rapor.BitisTarih,

      UcusTipi: _this.Rapor.UcusTipi,       

      CariKod: _this.Rapor.CariKod,

      KdvAyir: !!_this.Rapor.KdvAyir,

      RaporTip: _this.Rapor.RaporTip        

    };

    const mailObj = {

      To: (_this.mailPayload && _this.mailPayload.To) ? _this.mailPayload.To : "",

      AgencyName: (_this.mailPayload && _this.mailPayload.AgencyName) ? _this.mailPayload.AgencyName : "",

      DocType: (_this.mailPayload && _this.mailPayload.DocType)

        ? _this.mailPayload.DocType

        : "İade Bilet Fatura Kontrol Raporu - Return Ticket Invoice Check",

      AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",

      CustomBody: (_this.mailPayload && _this.mailPayload.CustomBody) ? _this.mailPayload.CustomBody : ""

    };

    const payload = {

      Input: inputObj,

      Mail: mailObj

    };

    _this.mailLoading = true;

    const endpoint = auth.API_URL + 'api/TicketReport/MailGonderİadeBiletFaturaExcel';

    _this.$http.post(

      endpoint,

      payload,

      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }

    ).then(function () {

      _this.mailLoading = false;

      _this.mailDialog = false;

      _this.text1 = 'Mail gönderildi.';

      _this.snackbar = true;

    }, function (err) {

      _this.mailLoading = false;

      const body = (err && (err.body || err.data)) ? (err.body || err.data) : {};

      const msg = (body && (body.Message || body.message)) || err.statusText || 'Mail gönderilemedi.';

      _this.text1 = msg;

      _this.snackbar = true;

    });

  },



    getList: getList,

    getListHtml: getListHtml,

    getListExcel: getListExcel,

    filtrele: filtrele,

    filtrekayit: filtrekayit,

    filtreiptal: filtreiptal,

  },

};

function filtrele() {

  this.dialogfiltre = true;

}

function filtrekayit() {

  this.filtrevarmi = true;

  this.dialogfiltre = false;

  this.getList();

}

function filtreiptal() {

  this.filtrevarmi = false;

  this.dialogfiltre = false;

  this.Rapor.CariKod = null;

  this.Rapor.UcusTipi = 0;

  this.Rapor.KdvAyir = false;

  this.Rapor.RaporTip = 0;

  this.tumsirketler = "";

}

function getList() {

  if (this.$refs.formgunluksatis.validate()) {
    this.reportHasSearched = true;

    this.kayitvarmi = false;

    this.progress = true;

    this.load1 = false;

    var credentials = JSON.parse(window.localStorage.getItem("credentials"));

    if (this.tumsirketler === true) {

      this.Rapor.SirketKodu = "0";

    } else {

      this.Rapor.SirketKodu = credentials.SirketKodu;

    }

    var params = this.Rapor;

    this.$http

      .post(auth.API_URL + "api/TicketReport/RefundRetunInvoiceList", params, {

        headers: {

          Authorization: "Bearer " + auth.getAuthHeader(),

        },

      })

      .then(

        (response) => {

          if (response.body.DatayList.length > 0) {

            this.kayitvarmi = true;

            this.itemRefund = response.body.DatayList;

            this.itemRefundSum = response.body.Toplamlar;

            this.progress = false;

            this.load1 = true;

          } else {

            this.text1 = this.$t("No-Records-Found");

            this.snackbar = true;

            this.progress = false;

            this.load1 = true;

          }

        },

        (response) => {

          if (response.status === 0) {

            this.text1 = "Service Unavailable-RefundRetunInvoiceList";

            this.snackbar = true;

            this.progress = false;

            this.load1 = true;

          } else {

            this.text1 = "Service Unavailable-RefundRetunInvoiceList";

            this.snackbar = true;

            this.progress = false;

            this.load1 = true;

          }

        }

      );

  }

}

function getListHtml() {

  if (this.$refs.formgunluksatis.validate()) {

    this.kayitvarmi = false;

    this.progress = true;

    this.load1 = false;

    var credentials = JSON.parse(window.localStorage.getItem("credentials"));

    var lang = localStorage.getItem('lang')

    if (this.tumsirketler === true) {

      this.Rapor.SirketKodu = "0";

    } else {

      this.Rapor.SirketKodu = credentials.SirketKodu;

    }

    var params = this.Rapor;

    this.$http

      .post(

        auth.API_URL + "api/TicketReport/RefundRetunInvoiceListHtml",

        params,

        {

          headers: {

            Authorization: "Bearer " + auth.getAuthHeader(),

          },

        }

      )

      .then(

        (response) => {

          this.progress = false;

          this.load1 = true;

          var blob = new Blob([response.data], {

            type: "application/html",

          });

          var link = document.createElement("a");

          link.href = window.URL.createObjectURL(blob);

          link.download = this.$t('ReturnTicketInvoiceCheck') + ".html";

          link.click();

        },

        (response) => {

          if (response.status === 0) {

            this.text1 = "Service Unavailable";

            this.snackbar = true;

            this.progress = false;

            this.load1 = true;

          } else {

            this.text1 = "Service Unavailable";

            this.snackbar = true;

            this.progress = false;

            this.load1 = true;

          }

        }

      );

  }

}

function getListExcel() {

  if (this.$refs.formgunluksatis.validate()) {

    this.kayitvarmi = false;

    this.progress = true;

    this.load1 = false;

    var credentials = JSON.parse(window.localStorage.getItem("credentials"));

    var lang = localStorage.getItem('lang')

    if (this.tumsirketler === true) {

      this.Rapor.SirketKodu = "0";

    } else {

      this.Rapor.SirketKodu = credentials.SirketKodu;

    }

    var params = this.Rapor;

    this.$http

      .post(auth.API_URL + "api/TicketReport/RefundRetunInvoiceExcel", params, {

        headers: {

          Authorization: "Bearer " + auth.getAuthHeader(),

        },

        responseType: "arraybuffer",

      })

      .then(

        (response) => {

          this.progress = false;

          this.load1 = true;

          if (lang=='en')

          {

             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);

             bodyhtml=bodyhtml.toString().replace('<title> İADE BİLET FATURA KONTROL </title>','<title> RETURN TICKET INVOICE CHECK </title>');

             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>İADE BİLET FATURA KONTROL</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>RETURN TICKET INVOICE CHECK</font>")

             bodyhtml=bodyhtml.toString().replace("Hava Yolu Code :","Airline Code :")

             bodyhtml=bodyhtml.toString().replace("Bilet No :","Ticket No :")

             bodyhtml=bodyhtml.toString().replace("HY Kodu","Airline Code")

             bodyhtml=bodyhtml.toString().replace("Bilet No","Ticket No")

             bodyhtml=bodyhtml.toString().replace("Uçuş Type","Flight Type")

             bodyhtml=bodyhtml.toString().replace("Yolcu Name","Passenger Name")

             bodyhtml=bodyhtml.toString().replace("Void Tarihi","Void Date")

             bodyhtml=bodyhtml.toString().replace("Satış Tarihi","Sales Date")

             bodyhtml=bodyhtml.toString().replace("Kesim Tarihi","Cutting Date")

             bodyhtml=bodyhtml.toString().replace("Bilet Amountı","Ticket Amount")

             bodyhtml=bodyhtml.toString().replace("Vergi Tutarı","Tax Amount")

             bodyhtml=bodyhtml.toString().replace("Discount Tutarı","Discount Amount")

             response.bodyText=bodyhtml;

          }

          var blob = new Blob([response.data], {

            type: "application/xlsx",

          });

          var link = document.createElement("a");

          link.href = window.URL.createObjectURL(blob);

          link.download = this.$t('ReturnTicketInvoiceCheck') + ".xlsx";

          link.click();

        },

        (response) => {

          if (response.status === 0) {

            this.text1 = "Service Unavailable";

            this.snackbar = true;

            this.progress = false;

            this.load1 = true;

          } else {

            this.text1 = "Service Unavailable";

            this.snackbar = true;

            this.progress = false;

            this.load1 = true;

          }

        }

      );

  }

}

function beforeMount() {}

</script>

<style scoped>

</style>